import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";
import { responsiveFontSize } from "@/styles/global";

const TableWrapper = styled(MainInner)`
    ${FondCardPadding}
    height: auto;
    overflow-x: auto;
    width: 100%;
`;

const TableContent = styled.table`
    margin-top: 30px;
`;

const TableHeader = styled.thead`
    width: 100%;
    margin-bottom: 6px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    padding: 7px 5px;
    font-weight: bold;

    td:last-child div {
        justify-content: flex-end;
    }
`;

const TableBody = styled.tbody`
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    min-width: 100%;
`;

const TableRow = styled.tr`
    width: 100%;

    td:last-child div {
        justify-content: flex-end;
    }
`;

const TableKey = styled.div`
    ${responsiveFontSize}
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans", sans-serif;
    display: flex;
    gap: 5px;
    text-align: left;
    
    svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
    }
`;

const TableValue = styled.td`
    ${responsiveFontSize}
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans", sans-serif;
    padding: 7px 0;
    margin-bottom: 6px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    text-align: right;    
    padding-right: 10px;

    &:first-child {
        text-align: left;
        min-width: 100px;

        @media (max-width: 768px) {
            min-width: 200px;
        }

        @media (max-width: 480px) {
            min-width: 140px;
        }
    }

    &:last-child {
        padding-right: 0;
    }
`;

const TableIcon = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 10px;
`;

const S = {
  TableWrapper,
  TableContent,
  TableBody,
  TableRow,
  TableHeader,
  TableKey,
  TableValue,
  TableIcon
};

export default S;
